import React, { Component } from 'react';
import {runtime} from 'rest/runtime';
import moment from 'moment-timezone';
import { actions } from 'actions';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';
import { Label } from 'widgets/default/Label';

class FileEntry extends Component {
  removeDocument = () => {
    var remove = confirm('Please confirm, to delete this element.');
    if (remove === true) {
      actions.deleteDocument(this.props.supplier, this.props.uid, this.props.type);
    }
  }

  download = () => {
    window.open(window.location.origin+'/rest/v2/supplier/'+ this.props.supplier + '/document/' + this.props.uid);
  }

  getRemoveIcon() {
    if (runtime.currentUser.isSupplier()) {
      return false;
    }
    else {
      return (
        <i onClick={this.removeDocument} className="fa fa-remove"></i>
      );
    }
  }

  getTypeLabel() {
    return {
      1: <Label type="info">NDA</Label>,
      3: <Label type="info">NDA (Voice Star)</Label>,
      2: <Label type="warning">Contract</Label>,
      4: <Label type="info">Broadcast Rate Card</Label>,
      5: <Label type="info">Non-Broadcast Rate Card</Label>,
      7: <Label type="info">Native Check</Label>,
    }[this.props.type] || 'N/A'
  }

  getUserTimeformat() {
    if (runtime.currentUser.get('timeformat') == 12) {
        return 'D. MMM YYYY, h:mm:ss A';
    }

    return 'D. MMM YYYY, H:mm:ss';
  }

  render() {
    return (
      <TableRow>
        <TableColumn>{this.getTypeLabel()}</TableColumn>
        <TableColumn>{moment(this.props.crdate, 'X').format(this.getUserTimeformat())}</TableColumn>
        <TableColumn>
          <strong>{this.props.filename}</strong>
          <span className="pull-right">
            <i className="fa fa-download download" onClick={this.download}></i>
            <span style={{padding: 5}}></span>
            {this.getRemoveIcon()}
          </span>
        </TableColumn>
      </TableRow>
    );
  }
}

export { FileEntry };
